import { _dataProvider } from '../dataProvider/DataProvider';

export const getUrlByParams = (url: string, params: Record<string, string>) => {
  const qrString = new URLSearchParams(params).toString();
  const isParams = url.includes('?');
  console.log('qrString', qrString);
  return `${url}${isParams ? '&' : '?'}${qrString}`;
};

interface IChannelProgramMedia {
  filename: string | undefined;
  params: Record<string, string>;
  channelId: number;
}

export const getChannelProgramMediaUrl = ({ filename, params, channelId }: IChannelProgramMedia) => {
  if (filename === undefined) {
    return '';
  }
  if (filename?.startsWith('http')) {
    return filename;
  } else {
    return getUrlByParams(`${_dataProvider.getServerUrl()}/channels/${channelId}/content/${filename}`, params);
  }
};

export const isValidUrlProtocol = (url: string): boolean => {
  if (!url || typeof url !== 'string') {
    return false;
  }
  try {
    const urlObj = new URL(url);
    return urlObj.protocol === 'http:' || urlObj.protocol === 'https:' || urlObj.protocol === 'data:';
  } catch {
    return false;
  }
};

export const validateAndOpenUrl = (url: string, onError?: () => void): boolean => {
  if (!url || typeof url !== 'string') {
    onError?.();
    return false;
  }
  if (!isValidUrlProtocol(url)) {
    onError?.();
    return false;
  }
  try {
    window.open(url, '_blank', 'noopener,noreferrer');
    return true;
  } catch (_error) {
    onError?.();
    return false;
  }
};
